/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

/**
 * Reset `.modal.modal-template` content on close and optionally set the
 * turbo-frame `src` from the trigger button's `data-frame-src`.
 *
 * On `hidden.bs.modal` the frame-loaded content is unmounted BEFORE the
 * `innerHTML` wipe (so its widgets, pages and timers tear down properly),
 * then the pristine template is restored and re-mounted.
 *
 * @type {Listener}
 */
export default {
    selector: '.modal.modal-template',
    connect(element, { app }) {
        const template = element.innerHTML

        const onShow = (e) => {
            const turboFrame = element.querySelector('turbo-frame')
            if (!turboFrame || !e.relatedTarget) {
                return
            }

            const { frameSrc } = e.relatedTarget.dataset
            if (frameSrc) {
                turboFrame.setAttribute('src', frameSrc)
            }
        }

        const onHidden = () => {
            // unmount() covers the modal itself, so this connect is torn down
            // too; mount() below re-runs it against the restored template.
            app.unmount(element)
            element.innerHTML = template
            app.mount(element)
        }

        element.addEventListener('show.bs.modal', onShow)
        element.addEventListener('hidden.bs.modal', onHidden)

        return () => {
            element.removeEventListener('show.bs.modal', onShow)
            element.removeEventListener('hidden.bs.modal', onHidden)
        }
    },
}
